var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "info-main" },
    [
      _c(
        "el-form",
        {
          staticClass: "page-form",
          attrs: { model: _vm.PersonInfo, "label-position": "left" },
        },
        [
          _c("p", { staticClass: "sub_t" }, [_vm._v("PersonInfo")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 40 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "FirstGivenName",
                        label: "First Given Name",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.PersonInfo.FirstGivenName || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { prop: "FirstSurName", label: "First Sur Name" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.PersonInfo.FirstSurName || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "Birth", label: "Date of Birth" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.PersonInfo.Birth || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        { staticClass: "page-form", attrs: { model: _vm.NationalIds } },
        [
          _c("p", { staticClass: "sub_t" }, [_vm._v("NationalIds")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 40 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "Number", label: "Number" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.NationalIds.Number || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "Type", label: "Type" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.NationalIds.Type || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }